import AuthApi from "@apis/auth.api";
import { useHtmlSignedCookie } from "@plugins/common/composables/use-html-signed-cookie.ts";
import { resourceSignedCookieService } from "@/modules/auth/service/resource.signed.cookie.service";

export default {
  logout(): Promise<unknown> {
    // Must run before the logout API call, which invalidates the jwt token needed to delete them
    return Promise.allSettled([
      useHtmlSignedCookie().clear(),
      resourceSignedCookieService.deleteResourceSignedCookie(),
    ]).then(() => AuthApi.logout());
  },
};
